export default __webpack_public_path__ + "static/media/sixth_section_background.d8178ec0.jpeg";